// Shared definitions for the "security wait by month / season" SEO archetype.
// Imported by the page template, the hub, and the sitemap so the month list and
// the thin-content indexability rule live in exactly one place.

// English month slugs, shared across locales (1=Jan..12=Dec), matching the
// English-slug convention used by travel-times ([day]) and best-time-to-arrive.
export const MONTH_SLUGS = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december'
];

// Thin-content floor: a month needs at least this many 5-minute samples before
// we treat its average as trustworthy enough to index. Below it, the page is
// rendered noindex and left out of the sitemap. (5-min sampling means a single
// fully covered month is ~8000 samples, so this only excludes near-empty months.)
export const MIN_SAMPLES = 500;

export const monthFromSlug = (slug) => MONTH_SLUGS.indexOf(slug) + 1; // 0 -> invalid
export const slugFromMonth = (month) => MONTH_SLUGS[month - 1];

// Build a Map(month -> entry) from a getMonthlyWaitAverages() result.
export const byMonthMap = (months) =>
    new Map((months || []).map((m) => [m.month, m]));

// Thin-content guard: a month is indexable only when it has a real average and
// enough samples to back it. Single source of truth for the page's noindex flag
// and the sitemap's inclusion decision.
export const isMonthIndexable = (entry) =>
    !!entry && entry.avgLow != null && (entry.samples || 0) >= MIN_SAMPLES;
